import { Search } from "react-feather";
import { Button, CardBody, Input, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import PaginationComponent from "Component/Learning/Common/Pagination";
import { setFilters } from "Features/Learning/MainPrograms/mainProgramSlice";
import { handleBackPagination, handleClickPagination, handleNextPagination } from "../MainProgram/MainProgramUtils";
import { setField } from "Features/Learning/Memberships/addMembershipSlice";
import { fetchMainProgram } from "Features/Learning/MainPrograms/Utils/MainProgramUtils";

const ModalAddProgram = ({ handleOpenProgram, openProgram, selectedValue, setSelectedValue }) => {
  const [dataProgram, setDataProgram] = useState([]);
  const [search, setSearch] = useState('');
  const filters = useSelector(state => state.MainProgram.filters)
  const isLoading = useSelector(state => state.MainProgram.isLoading)
  const pagination = useSelector((state) => state.MainProgram.data.pagination);
  const data = useSelector(state => state.Membership.detail)
  const dispatch = useDispatch();
  const [refatch, setRefatch] = useState(false);

  useEffect(() => {
    dispatch(fetchMainProgram({ ...filters }))
      .then((response) => {
        setDataProgram(response?.payload?.data)
      })
      .catch((error) => {
        console.error('Error fetching options:', error);
      });
  }, [dispatch, filters, refatch])

  const handleClickSearch = () => {
    setRefatch(!refatch);
  };

  const updateSearchParams = useCallback(() => {
    dispatch(
      setFilters({
        ...filters,
        "filter[title]": search,
        "page": 1
      })
    );
  }, [search]);

  useEffect(() => {
    const delay = setTimeout(updateSearchParams, 500);

    return () => clearTimeout(delay);
  }, [search]);

  const handleRadioChange = (item) => {
    setSelectedValue(item); // Simpan sebagai array dengan satu item saja
  };

  const handleSubmit = (e) => {
    e.preventDefault()

    dispatch(setField({ field: 'main_program_id', value: selectedValue?.id || "" }));
    handleOpenProgram(false)
  }

  return (
    <Modal isOpen={openProgram} size="lg">
      <ModalHeader onClick={handleOpenProgram}>
        Tambahkan Membership ke Program
      </ModalHeader>
      <ModalBody>
        <ul>
          {Object.keys(selectedValue).length > 0 &&
            <li>
              {selectedValue?.id} - {selectedValue?.title}
            </li>
          }
        </ul>
        <div className="faq-form mt-3">
          <Input
            className="form-control"
            type="text"
            placeholder="Search.."
            value={search}
            onKeyUp={(e) => (e.key === "Enter" ? handleClickSearch(e) : null)}
            onChange={(e) => setSearch(e.target.value)}
          />
          <Search className="search-icon" />
        </div>
        <Table className="table-responsive table-bordered my-3">
          <thead className="table-light">
            <tr>
              <th scope="col">{"#"}</th>
              <th scope="col">{"ID"}</th>
              <th scope="col">Nama Programs</th>
              <th scope="col" className="text-center">
                Pilih
              </th>
            </tr>
          </thead>
          <tbody>
            {dataProgram &&
              dataProgram.map((item, index) => (
                <tr key={`item-${index}`}>
                  <th>{pagination.from + index}</th>
                  <th>{item.id}</th>
                  <td>{item.title}</td>
                  <td className="text-center">
                    <Input
                      className="radio_animated"
                      name="programRadio"
                      type="radio"
                      checked={selectedValue && selectedValue?.id === item.id}
                      onChange={() => handleRadioChange(item)}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
        <CardBody>
          {(isLoading === false && pagination) && (
            <PaginationComponent
              pagination={pagination}
              handleBackPagination={() => handleBackPagination(pagination, filters, dispatch, setFilters, setRefatch)}
              handleClickPagination={(page) => handleClickPagination(page, filters, dispatch, setFilters, setRefatch)}
              handleNextPagination={() => handleNextPagination(pagination, filters, dispatch, setFilters, setRefatch)}
            />
          )}
        </CardBody>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => {
          handleOpenProgram(false)
          if (selectedValue?.id != data?.main_program?.id) setSelectedValue(data?.main_program || {})
        }}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSubmit}>
          Save
        </Button>{" "}
      </ModalFooter>
    </Modal>
  )
}

export default ModalAddProgram